import { FaqProps } from '../../types/components/pricing/Faq';

import Accordion from '../shared/Accordion';

const Faq: React.FC<FaqProps> = ({
  pageContent,
}) => {
  if (!pageContent?.faqs?.length) return;
  return (
    <section cy-test-id="faq" className="p-6 py-12 bg-gray-900 lg:p-16 md:py-24">
      <h2 className="eurostile uppercase text-[24px] lg:text-[48px] text-center font-medium pb-8">
        Frequently Asked Questions
      </h2>
      <Accordion items={pageContent.faqs} />
    </section>
  )
}

export default Faq;
